// Import jQuery
window.jQuery = require('jquery');
window.$ = global.jQuery;

// jQuery noConflict
var $ = jQuery.noConflict();

// Import Waypoints
require('waypoints/lib/jquery.waypoints');

// Nav Bar Gradient Animation
$(document).scroll(function() {
    if ($(window).scrollTop() <= 10) {
        // $("#site-header").removeClass('scrolled');
    } else {
        // $("#site-header").addClass('scrolled');
    }
});

// Hambur
$('#hambur').click(function() {
    $(this).toggleClass('open');
    $('.mobile-navigation').toggleClass('visible');
    $("#foo li").delay(200).fadeIn();
});

// Mobile class calls
$(window).on('resize', function() {
    var win = $(this);
    if (win.width() >= 1100) {
        $('.mobile-navigation').removeClass('visible');
        $('#hambur').removeClass('open');
    }
});

// Search close and open modals
$(document).ready(function() {
    $('.search-open').click(function() {
        $('body').toggleClass('noscroll');
        $('.search-modal').fadeToggle('1000', 'swing');
    });
    $('.search-close').click(function() {
        $('body').toggleClass('noscroll');
        $('.search-modal').fadeToggle('500', 'swing');
    });
    // $('.menu-item-has-children').hover(function() {
    // $('.sub-menu').toggle();
    // });
});

// Fade In Only
$(document).ready(function() {
    $('.faderIn').css('opacity', 0);
    //set a waypoint for all the page parts on the page
    var ppWaypoint = $('.faderIn').waypoint(function(direction) {
        //check the direction
        if (direction == 'down') {

            $(this.element).addClass('animated fadeIn');

        }
    }, {
        //Set the offset
        offset: '70%'
    });
});

// Fade In and Up - Big Up
$(document).ready(function() {
    $('.faderUp').css('opacity', 0);
    //set a waypoint for all the page parts on the page
    var ppWaypoint = $('.faderUp').waypoint(function(direction) {
        //check the direction
        if (direction == 'down') {
            //add the class to start the animation
            $(this.element).addClass('animated fadeInUp');
            // $('.fader-sub').addClass('animated fadeInUp delay-1s');
            //then destroy this waypoint, we don't need it anymore
            // this.destroy(); // Will prevent Waypoint from being triggered again, (trust me).
        }
    }, {
        //Set the offset
        offset: '70%'
    });
});

// Fade In and Left - Big Left
$(document).ready(function() {
    $('.faderLeft').css('opacity', 0);
    //set a waypoint for all the page parts on the page
    var ppWaypoint = $('.faderLeft').waypoint(function(direction) {
        //check the direction
        if (direction == 'down') {
            //add the class to start the animation
            $(this.element).addClass('animated fadeInLeft');
            // $('.fader-sub').addClass('animated fadeInUp delay-1s');
            //then destroy this waypoint, we don't need it anymore
            // this.destroy(); // Will prevent Waypoint from being triggered again, (trust me).
        }
    }, {
        //Set the offset
        offset: '70%'
    });
});

// Fade In and Right - Big Right
$(document).ready(function() {
    $('.faderRight').css('opacity', 0);
    //set a waypoint for all the page parts on the page
    var ppWaypoint = $('.faderRight').waypoint(function(direction) {
        //check the direction
        if (direction == 'down') {
            //add the class to start the animation
            $(this.element).addClass('animated fadeInRight');
            // $('.fader-sub').addClass('animated fadeInUp delay-1s');
            //then destroy this waypoint, we don't need it anymore
            // this.destroy(); // Will prevent Waypoint from being triggered again, (trust me).
        }
    }, {
        //Set the offset
        offset: '70%'
    });
});

// REMOVE FaderIn class. This will reset the Waypoint when page top equals 0. Not the way Waypoint Docs recommend (But oh well).
$(window).on("scroll", function() {
    var scrollPos = $(window).scrollTop();
    if (scrollPos <= 0) {
        $('.faderIn').removeClass('animated fadeIn');
    }
});

// HIDE NAV ON SCROLLDOWN
const showAnim = gsap.from('#site-header', { 
  yPercent: -100,
  paused: true,
  duration: 0.2
}).progress(1);

ScrollTrigger.create({
  markers: true,
  start: "top top",
  // end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? showAnim.play() : showAnim.reverse()
  }
});
